/**
 * The V8 soft card: no border, the card radius and shadow tokens from
 * `index.css` (`.card-soft`), on the surface colour in both themes.
 *
 * `as` keeps the element a page already used (a `<section>`, a `<div>`, an
 * `<article>`, a `<button>`), so swapping an inline card for this one changes
 * classes only, never the page's structure; `pad` is the inner padding,
 * `p-5` unless the page asked for another; any other prop (`onClick`,
 * `disabled`, `data-*`, …) passes through to that element.
 */
export default function Card({ as = 'section', title, action, pad = 'p-5', className = '', children, ...rest }) {
  const Tag = as
  return (
    <Tag className={`card-soft ${pad} ${className}`.trim()} {...rest}>
      {(title || action) && (
        <header className="mb-4 flex items-center justify-between gap-3">
          {title && <h2 className="text-sm font-semibold text-slate-700 dark:text-slate-200">{title}</h2>}
          {action}
        </header>
      )}
      {children}
    </Tag>
  )
}
